
import { REQUEST, SUCCESS, FAILURE } from '../../actions/constants'

import { LOOKUPS_DATA } from '../lookups/actions'

import {
  ALGOLIA_LISTINGS_DATA,
  ALGOLIA_LISTINGS_OF_BUILDING_DATA,
} from './actions'

const initialState = {
  isFetching: false,
  list: null,
  pagination: {
    total: 0,
    perPage: 0,
    currentPage: 1,
  },
  favListing: {
    id: null,
    makeActive: null,
  },

  isFetchingListingsForBuilding: false,
  listingsOfBuilding: null,
  listingsOfBuildingPagination: {
    total: 0,
    perPage: 0,
    currentPage: 1,
  },
}

const algoliaListingReducer = (state = initialState, action) => {
  const reducerState = Object.assign({}, state)
  switch(action.type) {
    // To Remove Data before mounting component and avoid flash of old data
    case LOOKUPS_DATA[REQUEST]:
      reducerState.isFetching = true
      reducerState.list = null
      break
    case ALGOLIA_LISTINGS_DATA[REQUEST]:
      reducerState.isFetching = true
      // reducerState.list = null
      break
    case ALGOLIA_LISTINGS_DATA[SUCCESS]:
      const responseData = action.response
      reducerState.list = responseData.hits
      reducerState.pagination = {
        total: responseData.nbHits,
        perPage: responseData.hitsPerPage,
        currentPage: responseData.page + 1,
      }
      reducerState.isFetching = false
      break
    case ALGOLIA_LISTINGS_DATA[FAILURE]:
      reducerState.isFetching = false
      reducerState.list = null
      break

    // To fetch and store the listings for specific building on click
    case ALGOLIA_LISTINGS_OF_BUILDING_DATA[REQUEST]:
      reducerState.isFetchingListingsForBuilding = true
      reducerState.listingsOfBuildingList = null

      break
    case ALGOLIA_LISTINGS_OF_BUILDING_DATA[SUCCESS]:

      reducerState.isFetchingListingsForBuilding = false
      const listingsOfBuildingResponseData = action.response
      reducerState.listingsOfBuilding = listingsOfBuildingResponseData.hits
      reducerState.listingsOfBuildingPagination = {
        total: listingsOfBuildingResponseData.nbHits,
        perPage: listingsOfBuildingResponseData.hitsPerPage,
        currentPage: listingsOfBuildingResponseData.page + 1,
      }
      break
    case ALGOLIA_LISTINGS_OF_BUILDING_DATA[FAILURE]:
      reducerState.isFetchingListingsForBuilding = false
      reducerState.listingsOfBuildingList = null
      break
  }

  return reducerState
}
export default algoliaListingReducer
